import React from 'react';
import { isArketBrand } from "@pb/utils/brandConfig";
import IconWrapper from '../IconWrapper';
const ArrowLeftIcon = (props) => {
    switch (true) {
        case isArketBrand:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" }),
                React.createElement("path", { fill: "#000", d: "M17.72 13.06v-1.4h-9L12.38 8l-1-1L6 12.38l5.38 5.38 1-1-3.7-3.7h9.04Z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M12.001 3L2 12.496l10.001 9.501.688-.726L4 12.996h18.001v-1H4l8.689-8.271z" })));
    }
};
export default ArrowLeftIcon;
//# sourceMappingURL=ArrowLeftIcon.js.map